import routing from "./hmr.routes";

//Controllers
import WorkflowController from "./controllers/workflow.controller";
import HmrController from "./controllers/hmr.controller";
import HmrAcceptModalController from "./controllers/modals/accept.controller";
import HmrErrorModalController from "./controllers/modals/error.controller";
import HmrOriginalReferralModalController from "./controllers/modals/original-referral.controller";
import HmrSubmitModalController from "./controllers/modals/submit.controller";
import HmrSupportingFilesModalController from "./controllers/modals/supporting-files.controller";
import HmrRefundRequestModalController from "./controllers/modals/refund-request.controller";

//Services
import DefaultDateService from "services/default-date.service";
import eCryptService from "services/eCrypt.service";
import HmrService from "services/hmr.service";
import MessageService from "services/message.service";

import phpPolyfillObjectFactory from "factories/php-polyfill-object.factory";

//Add to Angular
//noinspection JSValidateTypes
export default angular.module("hmrx.app.hmr", [
  DefaultDateService,
  eCryptService,
  HmrService,
  MessageService,
])
  .config(routing)
  //Add all controllers
  .controller("WorkflowController", WorkflowController)
  .controller("HmrController", HmrController)
  .controller("HmrAcceptModalController", HmrAcceptModalController)
  .controller("HmrErrorModalController", HmrErrorModalController)
  .controller("HmrOriginalReferralModalController", HmrOriginalReferralModalController)
  .controller("HmrSubmitModalController", HmrSubmitModalController)
  .controller("HmrSupportingFilesModalController", HmrSupportingFilesModalController)
  .controller("HmrRefundRequestModalController", HmrRefundRequestModalController)
  .factory("PhpPolyfillObject", phpPolyfillObjectFactory)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/referral/index.js
 **/